// This React component, `CustomFittingPage`, is a Next.js client component responsible for rendering the Custom
// Fitting landing page. It extracts data from the `dataSource` within the `data` prop and passes
// it to the `CustomFitting` component for display. By utilizing `TasticProps<CustomFittingPageType>`,
// it ensures type safety and structured data handling. This setup enables dynamic and efficient content
// rendering for the Custom Fitting page.

'use client';

import React from 'react';
import { TasticProps } from '../types';
import CustomFitting from 'components/commercetools-ui/organisms/landing-pages/custom-fitting';
import { CustomFittingPageType } from 'types/next';

const CustomFittingPage = ({ data }: TasticProps<CustomFittingPageType>) => {
  const customFitData = data?.data?.dataSource;
  return (
    <>
      <CustomFitting customFitData={customFitData} />
    </>
  );
};

export default CustomFittingPage;
